/* eslint-disable @typescript-eslint/no-this-alias */
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { LocalStorageService } from './localStorage.service';
import { Globals } from '../globals';

@Injectable()
export class PendoService {
  constructor(
    private localStorageService: LocalStorageService,
    private sessionService: SessionService,
    private globals: Globals
  ) {}

  installPendo() {
    const that = this;
    const env = environment;
    const pendoInstaller = (apiKey) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = env.pendoUrl + apiKey + '/pendo.js';
      script.onload = function () {
        if (window['pendo'] && typeof window['pendo'].initialize === 'function') {
          if (that.sessionService.getUserInfo()) {
            let userObj: any = null;
            const userStr = that.localStorageService.getItem('user');
            if (userStr) {
              try {
                userObj = JSON.parse(userStr);
              } catch (e) {
                userObj = null;
              }
            }
            if (userObj && userObj['username'] && userObj['email']) {
              const visitorId = userObj['username'];
              let isInternalUser = false;
              isInternalUser = that.globals.internalDomains.some((domain) => userObj['email'].endsWith(domain));
              window['pendo'].initialize({
                visitor: {
                  id: visitorId,
                  isInternalUser: isInternalUser,
                },
                account: { id: env.pendoAccountId },
              });
            } else {
              window['pendo'].initialize({
                account: { id: env.pendoAccountId },
              });
            }
          } else {
            window['pendo'].initialize({
              account: { id: env.pendoAccountId },
            });
          }
        }
      };
      document.head.appendChild(script);
    };
    pendoInstaller(environment.pendoApiKey);
  }

  clearPendoUserSession() {
    if (window['pendo']) {
      window['pendo'].clearSession();
    }
  }
}